import {
    MEDICATION_CHECK_IN_COMPLETE_PATH,
    MEDICATION_CHECK_IN_LABS_PATH,
    MEDICATION_CHECK_IN_LABS_UPLOAD_PATH,
    MEDICATION_CHECK_IN_PATH,
    MEDICATION_CHECK_IN_PROGRESS_PATH,
} from '@/lib/medicationCheckInLabFlow'
import { isPrescriptionCheckInReturnTo } from '@/lib/prescriptions/prescriptionCheckInFlow'

/**
 * Pathnames that render in-page focused-flow chrome instead of the global NavBar.
 *
 * Questionnaire matching is by exact `/questionnaire/{id}` and `/questionnaire/{id}/{step}`
 * patterns only — not a substring search. Any entry point (check-in, care plan, next steps)
 * uses those shared routes, including the `complete` step; deeper paths keep the NavBar.
 */
export function isFocusedFlowPage(pathname: string): boolean {
    if (/^\/provider\/[^/]+\/request-appointment\/?$/.test(pathname)) return true
    if (/^\/pharmacy\/[^/]+\/[^/]+\/request-prescription\/?$/.test(pathname)) return true
    if (pathname === MEDICATION_CHECK_IN_PATH) return true
    if (pathname === MEDICATION_CHECK_IN_LABS_PATH) return true
    if (pathname === MEDICATION_CHECK_IN_LABS_UPLOAD_PATH) return true
    if (pathname === MEDICATION_CHECK_IN_PROGRESS_PATH) return true
    if (pathname === MEDICATION_CHECK_IN_COMPLETE_PATH) return true
    if (isPrescriptionCheckInReturnTo(pathname)) return true
    if (pathname === '/care-journey/questionnaires') return true
    if (/^\/questionnaire\/[^/]+$/.test(pathname)) return true
    if (/^\/questionnaire\/[^/]+\/[^/]+$/.test(pathname)) return true
    return false
}
